/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

var xhrPromise = require('../client/xhr-promise');

// A function to prevent user losing data by displaying an "are you sure?" browser dialog
var onLeavePage = function onLeavePage(isDirty, event) {
  // Note: The Sure? strings below arent displayed to the user, so no translation needed
  // To trigger the dialog popup we must return a non-null, non-empty string value
  if (isDirty) {
    event = event || window.event;

    // For IE and Firefox prior to version 4
    if (event) {
      event.returnValue = "Sure?";
    }

    // For Safari
    return "Sure?";
  }
};
var checkSessionState = function checkSessionState(callback) {
  // Fetch session state and pass isExpired to the callback function
  xhrPromise('/api/v6/user-session/state', {
    dataType: 'json',
    method: 'GET'
  }).then(function (result) {
    var body = result.body;
    if (!body || !body.state || body.state === "inactive" || body.inactive_in <= 60) {
      // State is inactive, or session will expire in 1min or less -> treat as session inactive
      // The 60 second window ensures we update the react state to expired before the page attempts to redirect to login
      callback({
        inactiveTimeout: body.inactive_in,
        isExpired: true
      });
    } else {
      callback({
        inactiveTimeout: body.inactive_in,
        isExpired: false
      });
    }
  }).catch(function (error) {
    var message = error.message;
    console.log("Session state error: ".concat(message));
  });
};
module.exports = {
  checkSessionState: checkSessionState,
  onLeavePage: onLeavePage
};